import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  vi: {
    translation: {
      product: "SEO Intelligence",
      liveData: "Dữ liệu trực tiếp",
      demoData: "Dữ liệu mẫu",
      nav: {
        overview: "Tổng quan",
        rankings: "Thứ hạng từ khóa",
        traffic: "Lưu lượng tìm kiếm",
        matrix: "Ranking × Traffic",
        movers: "Winners / Losers",
        sync: "Trạng thái đồng bộ"
      },
      overview: {
        eyebrow: "Search performance command center",
        title: "Từ thứ hạng đến tăng trưởng thực",
        subtitle: "Kết nối tín hiệu SERP và Search Console theo từng thị trường.",
        visibility: "Phân bổ hiển thị",
        trend: "Xu hướng tìm kiếm",
        topKeywords: "Cơ hội nổi bật"
      },
      metrics: {
        clicks: "Clicks",
        impressions: "Impressions",
        ctr: "CTR",
        position: "Vị trí GSC",
        avgRank: "Thứ hạng TB"
      },
      common: {
        allMarkets: "Tất cả thị trường",
        allProjects: "Tất cả nhóm",
        last28Days: "28 ngày gần nhất",
        search: "Tìm từ khóa...",
        keyword: "Từ khóa",
        project: "Project",
        market: "Thị trường",
        rank: "Rank",
        change: "Thay đổi",
        traffic: "Traffic",
        status: "Trạng thái",
        updated: "Cập nhật",
        retry: "Chạy đồng bộ",
        loading: "Đang tải dữ liệu...",
        empty: "Chưa có dữ liệu cho bộ lọc này.",
        setup: "Kết nối Worker API để xem dữ liệu thực.",
        previous: "Trước",
        next: "Sau"
      }
    }
  },
  en: {
    translation: {
      product: "SEO Intelligence",
      liveData: "Live data",
      demoData: "Demo data",
      nav: {
        overview: "Overview",
        rankings: "Keyword rankings",
        traffic: "Search traffic",
        matrix: "Ranking × Traffic",
        movers: "Winners / Losers",
        sync: "Sync status"
      },
      overview: {
        eyebrow: "Search performance command center",
        title: "Turn rankings into measurable growth",
        subtitle: "Connect SERP signals and Search Console by market.",
        visibility: "Visibility distribution",
        trend: "Search trend",
        topKeywords: "Priority opportunities"
      },
      metrics: {
        clicks: "Clicks",
        impressions: "Impressions",
        ctr: "CTR",
        position: "GSC position",
        avgRank: "Average rank"
      },
      common: {
        allMarkets: "All markets",
        allProjects: "All projects",
        last28Days: "Last 28 days",
        search: "Search keywords...",
        keyword: "Keyword",
        project: "Project",
        market: "Market",
        rank: "Rank",
        change: "Change",
        traffic: "Traffic",
        status: "Status",
        updated: "Updated",
        retry: "Run sync",
        loading: "Loading data...",
        empty: "No data for these filters.",
        setup: "Connect the Worker API to view live data.",
        previous: "Previous",
        next: "Next"
      }
    }
  }
};

void i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("agrowth-language") ?? "vi",
  fallbackLng: "vi",
  interpolation: { escapeValue: false }
});

export default i18n;
